import { applicationSettingApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SYSTEM_SETTINGS_ACTION_TYPE = createNamedActions('systemSettings', {
  GET_SYSTEM_SETTINGS: 'GET_SYSTEM_SETTINGS',
  CREATE_SYSTEM_SETTING: 'CREATE_SYSTEM_SETTING',
  EDIT_SYSTEM_SETTING: 'EDIT_SYSTEM_SETTING',
  DELETE_SYSTEM_SETTING: 'DELETE_SYSTEM_SETTING',
});

const systemSettingsFields = new schema.Entity('data', {}, { idAttribute: 'applicationSettingId' });

export const getSystemSettingsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationSettingApi.getSystemSettings(params);

  return dispatch({
    type: SYSTEM_SETTINGS_ACTION_TYPE.GET_SYSTEM_SETTINGS,
    payload: normalize(data, [systemSettingsFields]).entities.data,
  });
});

export const createSystemSettingAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationSettingApi.createSystemSetting(params);

  return dispatch({
    type: SYSTEM_SETTINGS_ACTION_TYPE.CREATE_SYSTEM_SETTING,
    payload: data,
  });
});

export const editSystemSettingAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationSettingApi.editSystemSetting(params);

  return dispatch({
    type: SYSTEM_SETTINGS_ACTION_TYPE.EDIT_SYSTEM_SETTING,
    payload: data,
  });
});

export const deleteSystemSettingAction = catchAsyncActionError(params => async dispatch => {
  await applicationSettingApi.deleteSystemSetting(params);

  return dispatch({
    type: SYSTEM_SETTINGS_ACTION_TYPE.DELETE_SYSTEM_SETTING,
    meta: params,
  });
});
